import { ActivatedRoute, Params } from '@angular/router';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { AuthenticationService, OSService } from 'src/app/services';
import { ListaPaginada } from 'src/app/models';
import { Subscription, combineLatest } from 'rxjs';
import { IGetOsDetalheQueryParams, IOsDetalhe } from 'src/app/interfaces';
import { IToken } from 'src/app/interfaces/token/IToken';
import { ENVIRONMENT } from 'src/app/constants';
import { Environment } from 'src/app/types';

@Component({
  selector: 'app-listagem-de-os-visao-detalhada',
  templateUrl: './listagem-de-os-visao-detalhada.component.html',
  styleUrls: ['./listagem-de-os-visao-detalhada.component.scss']
})
export class ListagemDeOsVisaoDetalhadaComponent implements OnInit, OnDestroy {
  // @ViewChild(ModalGeneralComponent) modalEnviarMensagem: ModalGeneralComponent;
  subscriptions$ = new Subscription();
  routeParams: Params;
  queryParams: Params;
  detalhesOS = new ListaPaginada<IOsDetalhe>();
  // foto: 'string';
  token: IToken;
  constructor(
    private OSService: OSService,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    @Inject(ENVIRONMENT) public environment: Environment
  ) {}

  // openModal() {
  //   this.modalEnviarMensagem.openModal();
  // }

  // closeModal() {
  //   this.modalEnviarMensagem.closeModal();
  // }

  // inputFileChange(event) {
  //   if (event.target.files && event.target.files[0]) {
  //     this.foto = event.target.files[0].name;
  //   }
  // }

  getOSDetalhada(reiniciarPaginacao?: boolean) {
    if (reiniciarPaginacao) {
      this.detalhesOS.paginaAtual = 1;
    }

    const queryParams: IGetOsDetalheQueryParams = {
      idUsuario: this.token.id,
      codContrato: [this.routeParams.codContrato],
      numSerie: this.routeParams.numSerie,
      paginaAtual: this.detalhesOS.paginaAtual,
      itensPorPagina: this.detalhesOS.itensPorPagina
    };

    if (this.queryParams?.codigoOs) {
      queryParams.codigoOS = this.queryParams.codigoOs;
    }

    this.subscriptions$.add(
      this.OSService.getOSDetalhe(queryParams).subscribe(({ data }) => {
        this.detalhesOS = data;
      })
    );
  }

  private obterParametros<T extends Function = () => void>(
    executarAposObterParametros: T
  ) {
    this.subscriptions$.add(
      combineLatest([this.route.params, this.route.queryParams]).subscribe({
        next: ([routeParams, queryParams]) => {
          this.routeParams = routeParams;
          this.queryParams = queryParams;
          return executarAposObterParametros();
        }
      })
    );
  }

  ngOnInit(): void {
    this.obterParametros(() => {
      this.token = this.authenticationService.obterToken();
      this.getOSDetalhada();
    });
  }

  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }
}
